import React, { useState } from "react";
import { RxAvatar } from "react-icons/rx";

import { sanitizeLinkedinProfilePictureUrl } from "../../utils/linkedinProfilePicture";

export type LeadSenderAvatarProps = {
  picture?: string | null;
  /** Tailwind size classes, e.g. h-7 w-7 or h-8 w-8 */
  className?: string;
  disconnected?: boolean;
};

/**
 * LinkedIn sender / owner avatar: real photo when available, otherwise the same
 * RxAvatar placeholder used in the Leads table Sender column.
 */
export default function LeadSenderAvatar({
  picture,
  className = "h-8 w-8",
  disconnected = false,
}: LeadSenderAvatarProps) {
  const [failed, setFailed] = useState(false);
  const src = sanitizeLinkedinProfilePictureUrl(picture);

  if (!src || failed) {
    return <RxAvatar className={`${className} shrink-0 text-mainColor`} aria-hidden />;
  }

  return (
    <img
      src={src}
      alt=""
      aria-hidden
      className={`${className} shrink-0 rounded-full object-cover bg-[#eef1f4] ${
        disconnected ? "opacity-60" : ""
      }`}
      onError={() => setFailed(true)}
    />
  );
}
